import { render, staticRenderFns } from "./SuplementoEdadConductorMarca.vue?vue&type=template&id=23839df5&"
import script from "./SuplementoEdadConductorMarca.vue?vue&type=script&lang=js&"
export * from "./SuplementoEdadConductorMarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports